// extracted by mini-css-extract-plugin
export default {"ChoosePlanButton":"webpack-components-ChoosePlanButton-ChoosePlanButton-module__ChoosePlanButton"};